import ClpTable from "components/ClpTable"
import { t } from "i18next"

export const LoadingTable = () => {
  return (
    <ClpTable
      rows={[
        {
          loadingReport: t("global.downloading_report", "Downloading report..")
        }
      ]}
      columns={[
        {
          accessorKey: "loadingReport",
          header: t("global.status", "Status")
        }
      ]}
    />
  )
}
